import { useStaticQuery, graphql } from 'gatsby';


export const Fashion = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query fashionPosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "fashion-2" }) {
						nodes {
							title
							link
							colourFeatureImage
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
								mediaItemUrl
								}
							}    										
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};
